module.exports = __webpack_public_path__ + "static/media/25.fc8669c3.jpg";